import React from 'react';

import {
  SimpleFeedback,
  MollieFeedback,
  InstallmentFeedback,
  PayLaterFeedback,
} from '../../components/feedback/index.troy';

import {
  getQuestions,
  sendAnswers,
  checkMolliePaymentStatus,
} from '../../actions';
import { connectTo } from '../../utils';

import { getUrlParams } from '../../utils/httpUtil';

import {
  IDEAL_MOLLIE_VALUE,
  IDEAL_INSTALLMENT_VALUE,
  PAY_LATER_VALUE,
} from '../../constants/payment';

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    const params = getUrlParams();
    this.state = { page: params['page'] };
  }

  componentDidMount() {
    const { molliePaymentId, checkMolliePaymentStatus } = this.props;
    if (molliePaymentId) {
      checkMolliePaymentStatus(molliePaymentId);
    }
  }

  render() {
    const { molliePaymentId } = this.props;
    if (molliePaymentId) {
      return null;
    }

    switch (this.state.page) {
      case IDEAL_MOLLIE_VALUE: {
        return <MollieFeedback value={IDEAL_MOLLIE_VALUE} {...this.props} />;
      }
      case IDEAL_INSTALLMENT_VALUE: {
        return (
          <InstallmentFeedback
            value={IDEAL_INSTALLMENT_VALUE}
            {...this.props}
          />
        );
      }
      case PAY_LATER_VALUE: {
        return <PayLaterFeedback value={PAY_LATER_VALUE} {...this.props} />;
      }
      default: {
        return <SimpleFeedback {...this.props} />;
      }
    }
  }
}

export default connectTo(
  ({
    questions: { feedback },
    translations: { language, translations },
    ui: {
      feedback: { topImage },
    },
    payment: { molliePaymentId },
  }) => ({
    questions: feedback,
    language,
    translations,
    showTopImage: topImage,
    molliePaymentId,
  }),
  { getQuestions, sendAnswers, checkMolliePaymentStatus },
  Feedback
);
